<template>
  <div class="shopcart">
    <div class="main">
      <div class="cardPay">
        <van-cell-group title="储值卡支付">
          <van-checkbox-group v-model="checkedCards">
            <van-cell-group>
              <van-cell
                v-for="(item, index) in cardList"
                clickable
                :key="item.prepaidCardCode"
                :title="'卡号: ' + item.prepaidCardCode"
                :label="'结余: ' + fix2(item.surplus)"
                :value="-fix2(item.rePayAmt)"
                title-class="cardTitle"
                value-class="cardValue"
                label-class="cardLabel"
                @click="toggle(index)"
              >
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-cell-group>
      </div>
      <van-cell-group>
        <van-cell title="手机号" :value="showMobile" />
        <van-field
          v-model="smsCode"
          label="验证码："
          :rules="[
            {
              message: '短信校验码不能为空!',
              required: true,
            },
          ]"
          clearable
          name="smsCode"
          placeholder="请输入验证码"
        >
          <div slot="button">
            <div v-if="showCountDown">
              <van-count-down
                :time="smsTime"
                format="ss"
                @finish="countDownFinish"
              />
            </div>
            <div v-else class="smsCodeText" v-on:click="sendSmsCode">
              获取验证码
            </div>
          </div>
        </van-field>
      </van-cell-group>
      <!-- </van-checkbox> -->
      <van-goods-action>
        <van-goods-action-button
          style="width: 10px"
          type="danger"
          text="下一步"
          @click="dopay"
        />
      </van-goods-action>
    </div>

    <van-dialog
      title="收款码"
      class="qrcode-dialog"
      v-model="showDialog"
      showCancelButton
      :showConfirmButton="false"
      overlay
      @closed="closeTimer"
    >
      <van-tabs
        v-model="activeTab"
        style="margin-top: 10px"
        type="card"
        color="#C39C71"
      >
        <van-tab title="微信">
          <div class="content">
            <div class="cardno"></div>
            <div class="rechAmt">支付金额: {{ payAmt }}</div>
            <div class="qrcode" ref="weixinQrcode">
              <img :src="weixinQrCode" width="164px" height="164px" />
            </div>
          </div>
        </van-tab>
        <van-tab title="支付宝">
          <div class="content">
            <div class="cardno"></div>
            <div class="rechAmt">支付金额: {{ payAmt }}</div>
            <div class="qrcode" ref="aliQrCode">
              <img :src="aliQrCode" width="164px" height="164px" />
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </van-dialog>
  </div>
</template>

<script>
import "../../assets/css/cardPay.less";
import { apiPost } from "@/api/common";
import {} from "vant";
import { sendSmsCode } from "@/api/user";
import QRCode from "qrcode";
// const { checkboxGroup } = this.$refs;
export default {
  name: "CardPay",
  data() {
    return {
      totalAmt: "", //结算总额
      shopInfo: {}, //店铺信息
      cardInfo: {}, //存储客户信息的储值卡
      cartList: [], //待结算列表
      checkedCards: [], //选中的待支付储值卡
      cardList: [], //储值卡列表

      mobile: "",
      showMobile: "",
      smsCode: "",
      smsTime: 60 * 1000,
      showCountDown: false, //是否显示倒计时
      otherPayType: "",
      showDialog: false,
      weixinQrCode: "", //微信支付二维码
      aliQrCode: "",
      activeTab: "",
      payAmt: "",
      maxTimerCount: 300, //最大请求次数
      timer: false, //是否开启定时器
      timerCount: 0, //定时器计数器 ,每个支付最多查询300次
      orderNo: "",
    };
  },
  components: {},
  created() {
    this.loadComments();
  },
  computed: {},

  methods: {
    loadComments() {
      // debugger;
      let s = sessionStorage.getItem("shopInfo");
      let c = sessionStorage.getItem("cardInfo");
      this.shopInfo = s ? JSON.parse(s) : "";
      this.cardInfo = c ? JSON.parse(c) : "";
      this.mobile = this.cardInfo.tel;
      for (let i = 0; i < this.mobile.length; i++) {
        if (i > 2 && i < 7) {
          this.showMobile += "*";
        } else {
          this.showMobile += this.mobile[i];
        }
      }
      this.otherPayType = sessionStorage.getItem("otherPayType"); //待支付金额
      this.loadCard();

      //生成二维码
      // let codeurl = "http://baidu.com";
      // this.setQrcode(codeurl, 1);
    },
    fix2(val) {
      return Number(val).toFixed(2);
      // return val.toFixed(2);
    },
    setQrcode(codeurl, payType) {
      QRCode.toDataURL(codeurl)
        .then((codeurl) => {
          if (payType == 1) {
            this.weixinQrCode = codeurl;
          } else {
            this.aliQrCode = codeurl;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    loadCard() {
      let clist = sessionStorage.getItem("payCards");
      this.cardList = clist ? JSON.parse(clist) : [];
      let rePayAmt = parseFloat(sessionStorage.getItem("totalAmt")); //待支付金额
      for (let i = 0; i < this.cardList.length; i++) {
        let item = this.cardList[i];
        let cardAmt = parseFloat(item.surplusMoney);
        if (cardAmt >= rePayAmt) {
          item.rePayAmt = rePayAmt;
          rePayAmt = 0;
        } else {
          item.rePayAmt = cardAmt;
          rePayAmt = rePayAmt - cardAmt;
        }
        item.surplus = item.surplusMoney - item.rePayAmt;
      }
    },
    //发送短信验证码
    sendSmsCode() {
      let _this = this;
      sendSmsCode(_this.mobile, 2);
      _this.showCountDown = true;
      sessionStorage.setItem("sendTime", new Date().getTime());
    },

    dopay() {
      let _this = this;
      const url = "/api/order/pay";
      let valueCardList = [];
      for (let i = 0; i < _this.cardList.length; i++) {
        let item = {
          balance: _this.cardList[i].surplusMoney,
          cardNumber: _this.cardList[i].prepaidCardCode,
        };
        valueCardList.push(item);
      }
      let payType = sessionStorage.getItem("weixinOrAliapy");
      let data = {
        code: _this.smsCode,
        payType: payType,
        otherPayType: _this.otherPayType,
        phone: _this.mobile,
        shopCode: _this.shopInfo.shopCode,
        shopId: _this.shopInfo.id,
        staffId: _this.shopInfo.mobile,
        valueCardList: valueCardList,
      };

      apiPost(url, data).then((resp) => {
        let _data = resp.data;
        if (_data.code == "0000") {
          if (_this.otherPayType == 3) {
            //储值卡支付
            let payResult = {
              success: true,
              orderNo: this.orderNo,
            };
            sessionStorage.setItem("orderResult", JSON.stringify(payResult));
            this.$router.push("payResult");
          }
          if (_this.otherPayType == 4) {
            //其它支付方式
            this.orderNo = _data.data.results.orderNumber;
            this.getAliPayQrcode(this.orderNo);
            this.getWeixinPayQrcode(this.orderNo);
          }
        } else {
          _this.$toast.fail(_data.msg);
        }
      });
    },
    //改变计时状态
    countDownFinish() {
      this.showCountDown = false;
    },
    //获取支付宝二维码
    getAliPayQrcode(orderNo) {
      let payReqVo = {
        clerkId: this.shopInfo.id,
        shopId: this.shopInfo.shopCode,
        type: 1,
        orderId: orderNo,
        storeId: this.shopInfo.id,
      };
      let url = "/api/alipay/pay";
      apiPost(url, payReqVo)
        .then((resp) => {
          // debugger
          let _data = resp.data;
          if (_data.code == "0000") {
            let url = _data.data.results.payCode;
            this.payAmt = _data.data.results.totalAmount;
            //生成二维码
            QRCode.toDataURL(url).then((url) => {
              sessionStorage.setItem("alicode", url);
              this.aliQrCode = url;
            });
          } else {
            this.$toast.fail(_data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //获取微信二维码
    getWeixinPayQrcode(orderNo) {
      let _this = this;
      let url = "/api/wxpay/nativePay";
      let data = {
        clerkId: this.shopInfo.id,
        orderId: orderNo,
        storeId: this.shopInfo.shopCode,
        subject: "微信扫码付款",
        type: 1,
      };
      apiPost(url, data).then((resp) => {
        let _data = resp.data;
        if (_data.code == "0000") {
          //生成二维码
          this.setQrcode(_data.data.results.codeUrl, 1);
          this.showDialog = true;
          this.timer = true;
          this.timerStart(); //开启定时器，查询支付结果
          this.timerCount = 0; //初始化计时器
        } else {
          _this.$toast.fail(_data.msg);
        }
      });
    },
    //开启定时任务的方法，为了定时查询支付结果，以便后续页面跳转
    timerStart() {
      var _this = this;
      _this.checkPayResult = window.setInterval(() => {
        setTimeout(_this.timerEnd(), 0);
      }, 1000);
    },
    //定时任务开关控制器
    timerEnd() {
      if (this.timer && this.timerCount < this.maxTimerCount) {
        this.getPayResult();
        this.timerCount = this.timerCount + 1;
      } else {
        window.clearInterval(this.checkPayResult);
      }
    },
    //获取支付结果
    getPayResult() {
      let _this = this;
      let url = "/api/order/checkPay";
      let valueCardList = [];
      for (let i = 0; i < _this.cardList.length; i++) {
        let item = {
          balance: _this.cardList[i].surplusMoney,
          cardNumber: _this.cardList[i].prepaidCardCode,
        };
        valueCardList.push(item);
      }
      let payType = sessionStorage.getItem("weixinOrAliapy");
      let data = {
        orderId: this.orderNo,
        payType: payType,
        otherPayType: _this.otherPayType,
        phone: _this.mobile,
        storeCode: _this.shopInfo.shopCode,
        staffId: _this.shopInfo.id,
        valueCardList: valueCardList,
      };
      apiPost(url, data).then((resp) => {
        let _data = resp.data;
        if (_data.code == "0000") {
          if (_data.data.results.status) {
            //支付成功
            this.timer = false;
            this.showDialog = false;
            let payResult = {
              success: true,
              orderNo: this.orderNo,
            };
            sessionStorage.setItem("orderResult", JSON.stringify(payResult));
            this.$router.push("payResult");
          }
        }
      });
    },
    //关闭定时任务
    closeTimer() {
      this.timer = false;
    },
  },
};
</script>


